export default __webpack_public_path__ + "static/media/winner8.1ee51751.jpg";